"use client"

import type { I18nLocale } from "@/modules/i18n/types"
import type { FunctionComponent } from "react"

import classNames from "classnames"
import { useRouter } from "next/navigation"

import { Wand } from "@jobteaser/spark/components/Icons/Wand"
import { Tooltip } from "@jobteaser/spark/components/Tooltip"

import { PAGE_PATH } from "@/modules/aiCoverLetter/constants/routes"

import styles from "./Button.module.css"
import aiStyles from "@/modules/aiCoverLetter/components/AI.module.css"

type AppButtonProps = {
  className?: string
  locale: I18nLocale
  text: string
  title: string
}

export const AppButton: FunctionComponent<AppButtonProps> = ({ className, locale, text, title }) => {
  const { push } = useRouter()

  return (
    <Tooltip
      icon={Wand}
      className={classNames(aiStyles.button, styles.main, className)}
      content={title}
      onClick={() => {
        push(`/${locale}/${PAGE_PATH}`)
      }}
    >
      {text}
    </Tooltip>
  )
}
